import { Box } from "@mui/material";
import { styles } from "../styles";

type TypingIndicatorProps = {
  text?: string;
};

export function TypingIndicator({ text }: TypingIndicatorProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 0.5,
      }}
    >
      {text && (
        <Box
          sx={{
            fontSize: 13,
            opacity: 0.5,
            whiteSpace: "nowrap",
            mr: 0.5
          }}
        >
          {text}
        </Box>
      )}

      <Box sx={styles.typingContainer}>
        <Box sx={styles.dot} />
        <Box sx={styles.dotDelay1} />
        <Box sx={styles.dotDelay2} />
      </Box>
    </Box>
  );
}